import React, { Component } from 'react';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Theme from '../Theme';
import SummaryModul from '../SummaryModul';
import MessageModul from '../../MessageModul';
import DataStore from '../../stores/DataStore';

class TabsModul extends Component {
  constructor(params) {
    super(params);
    this.messageModules = [];
    this.state = { activeIndex: 0 };
  }

  getSummary() {
    const summary = <SummaryModul />;
    return summary;
  }

  getMessageModul(index) {
    const { activeIndex } = this.state;
    return (
      <MessageModul
        onMounted={(modul) => {
          this.messageModules[index] = modul;
          DataStore.getHandler().messageHandler.setMessageModul(
            this.messageModules[activeIndex],
          );
        }}
      />
    );
  }

  getTabs() {
    const { themes = [], attributes = [], debug, editToolbar } = this.props;
    const { activeIndex } = this.state;
    const tabs = [];
    const tabContainer = [];
    DataStore.getHandler().messageHandler.setMessageModul(
      this.messageModules[activeIndex],
    );
    for (let i = 0; i < themes.length; i++) {
      const theme = themes[i];
      tabs.push(<Tab label={theme.title} />);
      tabContainer.push(
        <div
          role="tabpanel"
          hidden={activeIndex !== i}
          id={`simple-tabpanel-${i}`}
          aria-labelledby={`simple-tab-${i}`}
        >
          <Theme themeOptions={theme} debug={debug} editToolbar={editToolbar} />
          {this.getFooter()}
          {this.getMessageModul(i)}
        </div>,
      );
    }

    tabs.push(<Tab label="" disabled />);
    tabContainer.push(
      <div
        role="tabpanel"
        hidden={activeIndex !== themes.length}
        id={`simple-tabpanel-${themes.length}`}
        aria-labelledby={`simple-tab-${themes.length}`}
      >
        {this.getSummary()}
      </div>,
    );

    return (
      <div>
        <AppBar position="static">
          <Tabs
            // style = {{
            //           flexContainer: {
            //             flexDirection: 'column',
            //           },
            //           indicator: {
            //             display: 'none',
            //           },
            //         }}
            value={activeIndex}
            onChange={(oldVal, newVal) => this.handleChange(newVal)}
          >
            {tabs}
          </Tabs>
        </AppBar>
        {tabContainer}
      </div>
    );
  }

  getFooter() {
    return (
      <div>
        <IconButton
          aria-label="send"
          onClick={() => {
            this.handleSend();
          }}
        >
          <SendRoundedIcon />
        </IconButton>
      </div>
    );
  }

  handleChange(activeIndex) {
    this.setState({ activeIndex });
  }

  handleSend() {
    const { saveChangesHandler } = DataStore.getHandler();
    const { themes } = this.props;
    saveChangesHandler.saveChanges(
      () => this.handleChange(themes.length),
      (errorLog) => {
        const errDetail = errorLog.map((o) => (
          <div>
            <div style={{ float: 'left', marginRight: '5px' }}>
              {`${o.name}: `}
            </div>
            {o.errText.map((t) => (
              <div>{t}</div>
            ))}
          </div>
        ));
        this.messageHandler.logDebugFormatted(
          'PagesModul',
          'handleSendErrorAnonym',
          '',
          this.props,
          this.state,
          errorLog,
        );
        this.messageHandler.setMessage(
          'error',
          'Fehler im Formular',
          errDetail,
        );
      },
    );
  }

  render() {
    const { themes = [], attributes = [], messageHandler } = this.props;
    this.messageHandler = messageHandler;
    return (
      <div>
        {this.getTabs()}
        {/* {this.getFooter()} */}
      </div>
    );
  }
}
export default TabsModul;
